/**************************************************
 * Nombre:       Dona_Limpia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import Chart from "react-apexcharts";
import {COLORES} from "../ContantesColorGraficas";

const Linea_Limpia = ({ancho, labels = [], series = [], marginTop = 0, height = 'auto'}) => {
    const options = {
        chart: {
            id: "area-bar",
            sparkline: {
                enabled: true,
            },
            toolbar: {
                show: false
            }

        },
        labels: labels,
        stroke: {
            width: 3,
            //curve: 'smooth',
        },
        colors: COLORES,
        dataLabels: {
            show: false,
            enabledOnSeries: false,

        },
        xaxis: {
            labels: {
                show: false,
            },
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            crosshairs: {
                show: false,

            },
        },
        yaxis: {
            series: false,
            //opposite: true,
            labels: {
                show: false
            },
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },

        },
        legend: {
            show: false
        },
        markers: {
            size: 3,
            strokeWidth: 1,
            strokeColors: '#1F7DFE',
        }

    }


    return (
        <Chart
            options={options}
            series={series}
            type="line"
            width={ancho}
            height={height}
            style={{marginTop: -24, marginBottom: -10}}
        />
    )

}
export default Linea_Limpia